import React from 'react';
import * as S from '../DetailsSection/details-section.styles';

const NoFlightFound = ({ handleCloseDtlSection }) => {
  return (
    <S.ListingOuter className="errorState dF flexCol justifyCenter alignItemsCenter">
      <p className="marginB20">
        <img src={'https://gos3.ibcdn.com/emptyState-1656584030.png'} width="188" height="83" />
      </p>
      <div className="fb quicksand font14 marginB10">
        We’re not able to fetch the flights for this destination right now.
      </div>
      <div className="font12 marginB20">
        While our team is at it, please explore other destinations.
      </div>
      <div className="viewAllfliBtn curPointFlt" onClick={handleCloseDtlSection}>
        CLOSE
      </div>
    </S.ListingOuter>
  );
};
export default NoFlightFound;
